import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEnhancedOnboardingCheck } from "../hooks/use-enhanced-onboarding-check";
import { IconLoader2 } from "@tabler/icons-react";

/**
 * Enhanced guard component that checks if a user needs onboarding and redirects if needed
 * Uses the enhanced onboarding check that leverages cached initialization data
 * Can be used with the Route component in App.tsx
 */
export function OnboardingGuard() {
  const { needsOnboarding, loading } = useEnhancedOnboardingCheck();
  const location = useLocation();

  // Don't redirect if already on onboarding page
  const isOnboardingRoute = location.pathname === "/onboarding";

  // Show loading state while checking
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-[50vh]">
        <IconLoader2 size={28} className="animate-spin text-medium mb-4" />
      </div>
    );
  }

  // Redirect to onboarding if needed and not already there
  if (needsOnboarding && !isOnboardingRoute) {
    return <Navigate to="/onboarding" replace />;
  }

  // Continue to the guarded route
  return <Outlet />;
}
